/* @ngInject */
function IaController ($rootScope, $scope, $cookies, $sce, AuthService, CONSTANTS) {
  $scope.jwt = $cookies.get('jwt')
  $scope.url = ''
  $scope.isLoading = true

  const activate = async () => {
    const user = await $rootScope.getUser()
    $scope.url = $sce.trustAsResourceUrl(`${CONSTANTS.URL_APP_V2}?page=chat&jwt=${$scope.jwt}&customerCompanyId=${user.customerCompanyId}`)
    $scope.isLoading = false
  }
  activate()

  const isValidEventOrigin = (origin) => {
    const urlToSearch = window.devEnv ? 'localhost' : '.deskfy.io'

    return origin.includes(urlToSearch)
  }

  const handleMessage = (event) => {
    if (!isValidEventOrigin(event.origin)) return

    if (event.data.type === 'logout') {
      AuthService.logout()
    }
  }

  $scope.$on('$destroy', () => {
    window.removeEventListener('message', handleMessage)
  })

  window.addEventListener('message', handleMessage)
}

export { IaController }
